import React, { lazy } from "react";
import { DictionaryKey } from "src/types/language";

import { FeScheme, MODALS, PAGES } from "src/types/navigation";

export type Roles = "guest" | "user";

export const pagesRedirect: Record<Roles, FeScheme> = {
  guest: [{ scheme: PAGES.ROOT }],
  user: [{ scheme: PAGES.POSITIONS }],
};

export type PageRoute = {
  access: "all" | Roles[];
  title: DictionaryKey;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: React.FC<any>;
  icon?: React.FC;
};
export type ModalRoute = PageRoute;

export const pages: Record<PAGES, PageRoute> = {
  [PAGES.EDIT_PROFILE]: {
    access: ["user"],
    title: "components.routes.pages.EditProfile.title",
    component: lazy(() => import("src/components/routes/pages/EditProfile")),
  },
  [PAGES.POSITIONS]: {
    access: ["user"],
    title: "components.routes.pages.Positions.title",
    component: lazy(() => import("src/components/routes/pages/Positions")),
  },
  [PAGES.EVENTS]: {
    access: "all",
    title: "components.routes.pages.Events.title",
    component: lazy(() => import("src/components/routes/pages/Events")),
  },
  [PAGES.EVENT_DETAIL]: {
    access: "all",
    title: "components.routes.pages.EventDetail.title",
    component: lazy(() => import("src/components/routes/pages/EventDetail")),
  },
  [PAGES.REFERALS]: {
    access: ["user"],
    title: "components.routes.pages.Referals.title",
    component: lazy(() => import("src/components/routes/pages/Referals")),
  },
  [PAGES.HISTORIES]: {
    access: ["user"],
    title: "components.routes.pages.Histories.title",
    component: lazy(() => import("src/components/routes/pages/Histories")),
  },
  [PAGES.NOTIFICATIONS]: {
    access: ["user"],
    title: "components.routes.pages.Notifications.title",
    component: lazy(() => import("src/components/routes/pages/Notifications")),
  },
  [PAGES.FAVORITES]: {
    access: "all",
    title: "components.routes.pages.Favorites.title",
    component: lazy(() => import("src/components/routes/pages/Favorites")),
  },
  [PAGES.TERMS]: {
    access: "all",
    title: "components.routes.pages.Terms.title",
    component: lazy(() => import("src/components/routes/pages/Terms")),
  },
  [PAGES.ROOT]: {
    access: "all",
    title: "components.routes.pages.Profile.title",
    component: lazy(() => import("src/components/routes/pages/Profile")),
  },
  // This item must be the last in the list
  [PAGES.ERROR_404]: {
    access: "all",
    title: "components.routes.pages.Error404.title",
    component: lazy(() => import("src/components/routes/pages/Error404")),
  },
};

export const modals: Record<MODALS, ModalRoute> = {
  [MODALS.SIGN_UP]: {
    access: "all",
    title: "components.routes.modals.SignUpEmail.title",
    component: lazy(() => import("src/components/routes/modals/SignUpEmail")),
  },
  [MODALS.SIGN_IN]: {
    access: "all",
    title: "components.routes.modals.SingInEmail.title",
    component: lazy(() => import("src/components/routes/modals/SingInEmail")),
  },
  [MODALS.VERIFY_CODE]: {
    access: "all",
    title: "components.routes.modals.VerifyCode.title",
    component: lazy(() => import("src/components/routes/modals/VerifyCode")),
  },
  [MODALS.FORGET_PASSWORD]: {
    access: "all",
    title: "components.routes.modals.ForgetPassword.title",
    component: lazy(
      () => import("src/components/routes/modals/ForgetPassword")
    ),
  },
  [MODALS.SEND_RESET_CODE]: {
    access: "all",
    title: "components.routes.modals.SendResetCode.title",
    component: lazy(() => import("src/components/routes/modals/SendResetCode")),
  },
  [MODALS.RESET_PASSWORD]: {
    access: "all",
    title: "components.routes.modals.ResetPassword.title",
    component: lazy(() => import("src/components/routes/modals/ResetPassword")),
  },
  [MODALS.DEPOSIT]: {
    access: ["user"],
    title: "components.routes.modals.Deposit.title",
    component: lazy(() => import("src/components/routes/modals/Deposit")),
  },
  [MODALS.DEPOSIT_ADDRESS]: {
    access: ["user"],
    title: "components.routes.modals.DepositAddress.title",
    component: lazy(
      () => import("src/components/routes/modals/DepositAddress")
    ),
  },
  [MODALS.WITHDRAW]: {
    access: ["user"],
    title: "components.routes.modals.Withdraw.title",
    component: lazy(() => import("src/components/routes/modals/Withdraw")),
  },
  [MODALS.WITHDRAW_FORM]: {
    access: ["user"],
    title: "components.routes.modals.WithdrawForm.title",
    component: lazy(
      () => import("src/components/routes/modals/WithdrawForm")
    ),
  },
  [MODALS.CRYPTO_LIST]: {
    access: ["user"],
    title: "components.routes.modals.CryptoList.title",
    component: lazy(
      () => import("src/components/routes/modals/CryptoList")
    ),
  },
};
